import { APP_PDC_URL, API_PARTY_REGISTRY_BASE_URL } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const apiType = {
  CREATE_PARTY_START: "CREATE_PARTY_START",
  CREATE_PARTY_SUCCESS: "CREATE_PARTY_SUCCESS",
  CREATE_PARTY_ERROR: "CREATE_PARTY_ERROR",

  EDIT_PARTY_START: "EDIT_PARTY_START",
  EDIT_PARTY_SUCCESS: "EDIT_PARTY_SUCCESS",
  EDIT_PARTY_ERROR: "EDIT_PARTY_ERROR",

  SEARCH_PARTY_START: "SEARCH_PARTY_START",
  SEARCH_PARTY_SUCCESS: "SEARCH_PARTY_SUCCESS",
  SEARCH_PARTY_ERROR: "SEARCH_PARTY_ERROR",

  GET_PARTY_START: "GET_PARTY_START",
  GET_PARTY_SUCCESS: "GET_PARTY_SUCCESS",
  GET_PARTY_ERROR: "GET_PARTY_ERROR",

  DELETE_PARTY_START: "DELETE_PARTY_START",
  DELETE_PARTY_SUCCESS: "DELETE_PARTY_SUCCESS",
  DELETE_PARTY_ERROR: "DELETE_PARTY_ERROR"
};

// http://localhost:8050/api/v1/party/b29dda79-ffab-4f5c-9a47-5f4bbfd1e65c/6048f2139046e7001b2eb0c7
export function getPartyById(
  auth, ownerId, partyId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: APP_PDC_URL + "/api/v1/party/" + ownerId + "/" + partyId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: apiType.GET_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: apiType.GET_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.GET_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.GET_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

// chiamate dirette al party-registry, da sostituire nei componenti con le action sul pdc definite sopra, quando il pdc sarà pronto

export function getParties(
  auth, ownerId, first = 10, sortDirection = "asc", fullText = "", sortBy = "_meta.createdAt"
) {
  return (dispatch) => {
    let url = `${APP_PDC_URL}/api/v1/party/${ownerId}?sortBy=${sortBy}&first=${first}&sortDirection=${sortDirection}`;
    if (fullText) {
      url = url.concat("&fullText=" + fullText);
    }
    return new Promise((resolve, reject) => {
      const request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: apiType.SEARCH_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: apiType.SEARCH_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.SEARCH_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.SEARCH_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function temporaryGetPartyById(
  auth, ownerId, partyId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = {
        method: "GET",
        url: `${API_PARTY_REGISTRY_BASE_URL}/api/v1/${ownerId}/parties/${partyId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: apiType.GET_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202 || result.status === 201) {
            dispatch({
              type: apiType.GET_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.GET_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.GET_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function createParty(
  auth, ownerId, bodyRequest
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = {
        method: "POST",
        url: `${APP_PDC_URL}/api/v1/party/${ownerId}/parties`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data:
          bodyRequest.type === "COMPANY"
            ? {
              identifiers: bodyRequest.identifiers,
              relationships: bodyRequest.relationships,
              description: bodyRequest.description,
              type: bodyRequest.type,
              name: bodyRequest.name,
              title: bodyRequest.title ? bodyRequest.title : "",
              firstName: bodyRequest.firstName,
              lastName: bodyRequest.lastName,
              legalNature: bodyRequest.legalNature ? bodyRequest.legalNature : "",
              emailAddresses: bodyRequest.emailAddresses,
              places: bodyRequest.places,
              bankAccounts: bodyRequest.bankAccounts ? bodyRequest.bankAccounts : [],
              negotiatedPaymentPlans: bodyRequest.negotiatedPaymentPlans ? bodyRequest.negotiatedPaymentPlans : [],
              sdiId: bodyRequest.sdiId ? bodyRequest.sdiId : "",
              taxRepresentative: bodyRequest.taxRepresentative
            }
            : {
              identifiers: bodyRequest.identifiers,
              relationships: bodyRequest.relationships,
              description: bodyRequest.description,
              type: bodyRequest.type,
              title: bodyRequest.title ? bodyRequest.title : "",
              firstName: bodyRequest.firstName,
              lastName: bodyRequest.lastName,
              emailAddresses: bodyRequest.emailAddresses,
              places: bodyRequest.places,
              bankAccounts: bodyRequest.bankAccounts ? bodyRequest.bankAccounts : [],
              negotiatedPaymentPlans: bodyRequest.negotiatedPaymentPlans ? bodyRequest.negotiatedPaymentPlans : [],
              sdiId: bodyRequest.sdiId ? bodyRequest.sdiId : ""
            }
      };

      dispatch({
        type: apiType.CREATE_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202 || result.status === 201) {
            dispatch({
              type: apiType.CREATE_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.CREATE_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.CREATE_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function editParty(
  auth, ownerId, bodyRequest, partyId, latestVersion
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = {
        method: "PUT",
        url: `${APP_PDC_URL}/api/v1/party/${ownerId}/${partyId}?latestKnownVersion=${latestVersion}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data:
          bodyRequest.type === "COMPANY"
            ? {
              identifiers: bodyRequest.identifiers,
              relationships: bodyRequest.relationships,
              description: bodyRequest.description,
              type: bodyRequest.type,
              name: bodyRequest.name,
              title: bodyRequest.title ? bodyRequest.title : "",
              firstName: bodyRequest.firstName,
              lastName: bodyRequest.lastName,
              legalNature: bodyRequest.legalNature ? bodyRequest.legalNature : "",
              emailAddresses: bodyRequest.emailAddresses,
              places: bodyRequest.places,
              bankAccounts: bodyRequest.bankAccounts ? bodyRequest.bankAccounts : [],
              negotiatedPaymentPlans: bodyRequest.negotiatedPaymentPlans ? bodyRequest.negotiatedPaymentPlans : [],
              sdiId: bodyRequest.sdiId ? bodyRequest.sdiId : "",
              taxRepresentative: bodyRequest.taxRepresentative
            }
            : {
              identifiers: bodyRequest.identifiers,
              relationships: bodyRequest.relationships,
              description: bodyRequest.description,
              type: bodyRequest.type,
              title: bodyRequest.title ? bodyRequest.title : "",
              firstName: bodyRequest.firstName,
              lastName: bodyRequest.lastName,
              emailAddresses: bodyRequest.emailAddresses,
              places: bodyRequest.places,
              bankAccounts: bodyRequest.bankAccounts ? bodyRequest.bankAccounts : [],
              negotiatedPaymentPlans: bodyRequest.negotiatedPaymentPlans ? bodyRequest.negotiatedPaymentPlans : [],
              sdiId: bodyRequest.sdiId ? bodyRequest.sdiId : ""
            }
      };

      dispatch({
        type: apiType.EDIT_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202 || result.status === 201) {
            dispatch({
              type: apiType.EDIT_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.EDIT_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.EDIT_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function deleteParty(
  auth, ownerId, partyId, latestVersion
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = {
        method: "DELETE",
        url: `${APP_PDC_URL}/api/v1/party/${ownerId}/${partyId}?latestKnownVersion=${latestVersion}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: apiType.DELETE_PARTY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 204) {
            dispatch({
              type: apiType.DELETE_PARTY_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: apiType.DELETE_PARTY_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: apiType.DELETE_PARTY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
